import { $el } from '../elements';
import { UIClassesSpec } from '../types';

export namespace $soundcloud {
    const link_regex = /^https.*soundcloud\.com.*$/;

    export function isValidLink(link: string) {
        return link_regex.test(link);
    }

    export function player(url: string, classes?: UIClassesSpec) {
        const iframe = $el.IFRAME('https://w.soundcloud.com/player/?url=' + encodeURIComponent(url) + '&color=e38d91&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=false&visual=true', classes);
        // iframe.setAttribute('allow', 'encrypted-media');
        return iframe;
    }
}